import styled from 'styled-components';

const Wrapper = styled.div`
  width: 30px;
  color: ${(props) => props.theme.colors.text};

  .icon {
    color: ${(props) => props.theme.colors.text};
  }
`;

export default { Wrapper };
